import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const StarSixPointEmpty = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="empty six point star icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0541 7.04097L12 3.05397L9.9459 7.04097L5.6742 5.6742L7.04097 9.9459L3.05397 12L7.04097 14.0541L5.6742 18.3258L9.9459 16.959L12 20.946L14.0541 16.959L18.3258 18.3258L16.959 14.0541L20.946 12L16.959 9.9459L18.3258 5.6742L14.0541 7.04097ZM0.601312 12.9862L4.62027 15.0568L3.24255 19.3627C2.9677 20.2217 3.77827 21.0323 4.63727 20.7575L8.94322 19.3797L11.0138 23.3987C11.4268 24.2004 12.5732 24.2004 12.9862 23.3987L15.0568 19.3797L19.3627 20.7575C20.2217 21.0323 21.0323 20.2217 20.7575 19.3627L19.3797 15.0568L23.3987 12.9862C24.2004 12.5732 24.2004 11.4268 23.3987 11.0138L19.3797 8.94322L20.7575 4.63727C21.0323 3.77827 20.2217 2.9677 19.3627 3.24255L15.0568 4.62027L12.9862 0.601312C12.5732 -0.200437 11.4268 -0.200437 11.0138 0.601312L8.94322 4.62027L4.63727 3.24255C3.77827 2.9677 2.9677 3.77827 3.24255 4.63727L4.62027 8.94322L0.601312 11.0138C-0.200437 11.4268 -0.200437 12.5732 0.601312 12.9862Z"
    />
  </svg>
)
